import React from 'react'

const ViewModeContext = React.createContext({})

export default ViewModeContext
export const ViewModeProvider = ViewModeContext.Provider
export const ViewModeConsumer = ViewModeContext.Consumer
